import { z } from "zod";

const FlightBookingChangeEntrySchema = z.object({
  roundedDownTransactionDate: z.string().optional(),
  quarter: z.string().optional(),
  month: z.string(),
  year: z.string(),
  rescheduled_transactions: z.string(),
  canceled_with_refund_transactions: z.string(),
  canceled_without_refund_transactions: z.string(),
});

export const FlightBookingChangesResultSchema = z.object({
  flightBookingChanges: z.object({
    transactions: z.array(FlightBookingChangeEntrySchema),
  }),
});

export type FlightBookingChangesResult = z.infer<
  typeof FlightBookingChangesResultSchema
>;
